// pages/LoginPage.js
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { login } from '../../features/auth/authSlice';

import loginImage from "../../images/login-bg-1.jpg";
import beetinqlogowhite from "../../images/beetinq/beetinqlogowhite.png";

function LoginEmail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoading, isError, isSuccess, message } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    email: '',
    parola: '',
  });

  const [showPassword, setShowPassword] = useState(false);

  const { email, parola } = formData;
  const from = location.state?.from?.pathname || "/";

  useEffect(() => {
    if (isError) {
      toast.error(message);
    }

    if (isSuccess || user) {
      navigate(from);
    }
  }, [user, isError, isSuccess, message, navigate, from]);

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!email || !parola) {
      toast.warning("Lütfen e-posta ve şifrenizi girin.");
      return;
    }

    dispatch(login({ email, parola }));
  };

  const handleForgotPassword = () => {
    window.location.assign('https://auth.beetinq.com');
  };

  return (
    <div className="login-wrapper">
      <div className="login-aside-left" style={{ backgroundImage: "url(" + loginImage + ")" }}>
        <Link to="/" className="login-logo">
          <img src={beetinqlogowhite} alt="" width={"60%"} />
        </Link>
        <div className="login-description">
          <h2 className="text-white mb-4">Toplantılarınız<br></br>İş Etkinlikleriniz<br></br>için Ortak Platform</h2>
          <p className="fs-16">beetinq ile Toplantı ve İş Etkinliği oluşturun, paylaşın ve iş birliği yapın. En büyük iş ağı platformunda yerinizi alın.</p>
          <ul className="social-icons mt-4">
            <li><Link to={"https://www.facebook.com/beetinq"}><i className="fa fa-facebook"></i></Link></li>
            <li><Link to={"https://www.instagram.com/beetinq"}><i className="fa fa-instagram"></i></Link></li>
            <li><Link to={"https://www.linkedin.com/company/beetinq"}><i className="fa fa-linkedin"></i></Link></li>
            <li><Link to={"https://beetinq.com"}><i className="fa fa-globe"></i></Link></li>
          </ul>
          <div className="mt-5">
            <Link to={"https://beetinq.com/"} className="text-white">© 2021 beetinq</Link>
          </div>
        </div>
      </div>
      <div className="login-aside-right">
        <div className="row m-0 justify-content-center h-100 align-items-center">
          <div className="col-xl-6 col-xxl-8">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">

                    <div className=" mb-3">
                      <h2 className="text-info">Hoşgeldiniz</h2>
                    </div>

                    <h4 className=" mb-4 ">Bilgileri girerek oturum açın</h4>

                    <form onSubmit={onSubmit}>
                      <div className="form-group mb-3">
                        <label className="">
                          <strong>E-posta Adresiniz</strong>
                        </label>
                        <input
                          type="email"
                          className="form-control  mb-3"
                          name="email"
                          value={email}
                          onChange={onChange}
                          placeholder="E-posta"
                          autoComplete="email"
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label className="">
                          <strong>Şifreniz</strong>
                        </label>
                        <div style={{ position: 'relative' }}>
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control mb-3"
                            name="parola"
                            value={parola}
                            onChange={onChange}
                            placeholder="Şifre"
                            autoComplete="current-password"
                            style={{ paddingRight: '2.5rem' }}
                          />
                          <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                              position: 'absolute',
                              right: '0.75rem',
                              top: '50%',
                              transform: 'translateY(-65%)',
                              background: 'none',
                              border: 'none',
                              cursor: 'pointer',
                              color: '#6c757d',
                              padding: 0,
                              lineHeight: 1,
                            }}
                            tabIndex={-1}
                          >
                            <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                          </button>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end mb-3">
                        <button
                          type="button"
                          className="btn btn-link p-0 text-info"
                          onClick={handleForgotPassword}
                        >
                          Şifremi unuttum
                        </button>
                      </div>

                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn btn-info btn-block"
                          disabled={isLoading}
                        >
                          {isLoading ? "Giriş yapılıyor..." : "Giriş"}
                        </button>
                      </div>
                    </form>

                    <div className="text-center mt-3">
                      <p>veya</p>
                      <button
                        type="button"
                        className="btn btn-outline-info btn-block"
                        onClick={() => navigate('/loginphone')}>
                        Telefon ile Giriş Yap
                      </button>
                    </div>

                    <div className="text-center mt-3">
                      <p>Hesabınız yok mu?</p>
                      <button
                        type="button"
                        className="btn btn-outline-info btn-block"
                        onClick={() => navigate('/register')}
                      >
                        Kayıt Ol
                      </button>
                    </div>

                    <div id="recaptcha"></div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default LoginEmail;
